module.exports = __webpack_public_path__ + "img/no-data-eval.4702eb4a.svg";